module.exports = __webpack_public_path__ + "static/media/icon-arrow--long--right--dark.2a3a95ea.svg";